import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SessionExpiredModalPage } from 'src/app/modals/session-expired-modal/session-expired-modal.page';

@Injectable({
  providedIn: 'root',
})
export class SessionExpiredModalService {
  private open = false;

  constructor(private modalCtrl: ModalController) {}

  async present(message: string, onOk: () => void): Promise<void> {
    if (this.open) {
      return;
    }
    this.open = true;
    const modal = await this.modalCtrl.create({
      component: SessionExpiredModalPage,
      componentProps: {
        message,
        onConfirm: () => {
          this.open = false;
          modal.dismiss();
          document.querySelectorAll('ion-modal').forEach((e: any) => e.remove());
          document.querySelectorAll('.popover-viewport').forEach((e: any) => e.remove());
          document.querySelectorAll('.loading-blocker').forEach((e: any) => e.remove());
  
          onOk();
        },
      },
      backdropDismiss: true,
      canDismiss: false,
      keyboardClose: false,
      showBackdrop: true,
      cssClass: 'session-expired-modal-blocking  keep-this',
    });
    await modal.present();
    modal.onDidDismiss().then(() => {
      this.open = false;
    });
  }
}
